import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken } from 'services/apiUtils';

const Publico: React.FC<{ element: React.ReactNode }> = ({ element }) => {
  const token = getAuthToken();

  if (token) {
    return <Navigate to="/usuario" />;
  }
  return <>{element}</>;
};

export default Publico;
